module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/epigraph#epg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgments#ack01"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "atn_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/authorsnote#atn01"
    }
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('a', {
    attrs: {
      "href": "#/prologue"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("PROLOGUE")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "pro_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/prologue#pro01"
    }
  }, [_vm._v("Go Forward")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "pt_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part01#pt01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NE")])])])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#ch01"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 1")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#ch01"
    }
  }, [_vm._v("Candy")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 2")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The No-Daddy Blues")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 3")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where’s Momma?")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 4")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bitches Brew (side a)")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 5")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bitches Brew (side b)")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "pt_02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WO")])])])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 6")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World Beyond")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 7")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pictures of a Life")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "phi_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07a#phi01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographic Insert")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 8")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turned Out (an intro)")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 9")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turned Out (advanced)")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 10")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("California Dreamin’")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "pt_03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HREE")])])])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 11")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roses in the Ghetto")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHAPTER 12")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sphere of Influence")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EPILOGUE")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "epi_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue#epi01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blessed Beyond the Dreams of a Thousand Men")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "crd_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/credits#crd01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright#cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1"
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/aboutthepublisher#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0